// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3Y-e2","errors":"Errors_errors__Y5pZ1"};